module.exports = __webpack_public_path__ + "img/3.f4c9ece2.png";